'use client'

import { AXIOS_INSTANCE } from '@cocoonspace/sdk-js/axios-client/use-custom-instance'
import { AXIOS_INSTANCE as AXIOS_INSTANCE_SDK_V2 } from '@cocoonspace/sdk-js/v2/use-custom-instance'

import { envClient } from '~/lib/env'
import { accessTokenInterceptor } from '~/lib/interceptors/access-token.interceptor'

let didInit = false

export const initClientSdks = () => {
	if (didInit) return
	didInit = true

	if (envClient.NEXT_PUBLIC_APP_ENV !== 'prod') {
		AXIOS_INSTANCE.defaults.baseURL = `${envClient.NEXT_PUBLIC_API_BASE_URL}/v1`
	}

	AXIOS_INSTANCE.interceptors.request.use(accessTokenInterceptor)

	AXIOS_INSTANCE_SDK_V2.defaults.baseURL =
		envClient.NEXT_PUBLIC_COCOON_API_V2_BASE_URL
	AXIOS_INSTANCE_SDK_V2.interceptors.request.use(accessTokenInterceptor)
}
